module.exports = __webpack_public_path__ + "img/order-back.9e9dedfd.png";